/**
 * ================================================================================================
 *  LEAVING THIS APPLICATION — ONE FUNCTION, BECAUSE THERE IS ONE RULE ABOUT IT
 * ================================================================================================
 *
 * Two screens send the browser to another company's server: `SignupVerifyScreen` at step four of a
 * registration, and `PaymentMethodPanel` when an office replaces its card. Both go to a provider-
 * hosted payment page, and in both cases the rule is the same and is the whole content of this
 * module:
 *
 *   **THE ADDRESS IS THE SERVER'S, VERBATIM.**
 *
 * It came back from the route, which got it from Cardcom's `LowProfile/Create` answer. Nothing in
 * this application composes it, appends to it, or validates it into a different one. A URL
 * assembled in a browser is a URL a browser can choose — and the thing being chosen here is where
 * a customer types a card number.
 *
 * ── WHY A FUNCTION AND NOT `window.location.assign` AT THE TWO CALL SITES ──────────────────────
 *
 * Two reasons, and the second is the one that matters.
 *
 *   1. A SEAM A TEST CAN DRIVE. `jsdom` makes `location.assign` non-configurable, so a rendered
 *      test cannot spy on it — which would have left the redirect as the primary path of a
 *      card-entry journey with no rendered test taking it. That is exactly the shape of gap this
 *      repository has paid for before: a control that reads a file instead of running it.
 *   2. ONE PLACE THE RULE IS WRITTEN. A second call site is a second place somebody can decide to
 *      "improve" the address — add a return parameter, force a scheme, normalise a host. Each of
 *      those is a change to where a card is typed, and none of them belongs in a screen.
 *
 * IT DOES NOT VALIDATE THE URL, and that is deliberate rather than an omission. A check here would
 * be a second opinion about an address this application did not choose: if the value is not
 * Cardcom's, the fault is upstream — a compromised route answer or a provider we should not be
 * talking to — and a client-side allow-list would turn that into a silent failure on the one screen
 * whose job is to hand over to the provider. `cardcom-client.ts` pins the host it will speak to, on
 * the server, where the credential is.
 */

export function leaveTo(url: string): void {
  window.location.assign(url);
}
